module.exports = __webpack_public_path__ + "img/avatar2.d14801b2.png";